mod.modules.define("FinancialStatements", "BaseModule", function(fn) {
	"use strict";

	fn.prototype.init = function(params) {
		this.base("init", params);
	};

	fn.prototype.events = {
		"button[data-action]:not(.active)": {
			"click": function(e, $el) {
				this.reload({
					CurrentType: $el.attr("data-action")
				});
			}
		},
		".financialstatement-controls select": {
			"change": function(e, $el) {
				this.reload({
					Period: $el.val()
				});
			}
		}
	};

});